// @flow
import React from "react";
import MatchCentre from "../../../components/MatchCentre";
import { withDraftPlayerModal } from "../../../components";

export const DraftMatchCentre = (props: Object) => {
	return <MatchCentre {...props} />;
};

export default withDraftPlayerModal(MatchCentre);